
import { createSlice } from '@reduxjs/toolkit'
import { TimelineInsert ,TimelineGet ,TimelineLike,CompanyTimeline,CommentInsert,GetComment,DeletePost} from '../api/TimelineApi'

const initialState = {
    loading:false,
    timelineData:[],
    companytimeline:{},
    getcomments:{},
}

export const TimelineSlice = createSlice({
  name: 'TimelineSlice',
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder.addCase(TimelineInsert.pending, (state, action) => {
        state.loading = true;
      })
      builder.addCase(TimelineInsert.fulfilled , (state, action) => {
        state.loading = false;
       
      })
      builder.addCase(TimelineInsert.rejected, (state, action) => {
        state.loading = false;
      
      })


      // slice to get timeline
      builder.addCase(TimelineGet.pending, (state, action) => {
        state.loading = true;
      })
      builder.addCase(TimelineGet.fulfilled , (state, action) => {
        state.loading = false;
        state.timelineData=action.payload;
      })
      builder.addCase(TimelineGet.rejected, (state, action) => {
        state.loading = false;
      
      })

     
       // slice to like timeline
       builder.addCase(TimelineLike.pending, (state, action) => {
        state.loading = false;
      })
      builder.addCase(TimelineLike.fulfilled , (state, action) => {
        state.loading = false;
      })
      builder.addCase(TimelineLike.rejected, (state, action) => {
        state.loading = false;
      
      })

       // slice of company timeline
       builder.addCase( CompanyTimeline.pending, (state, action) => {
        state.loading = false;
      })
      builder.addCase( CompanyTimeline.fulfilled , (state, action) => {
        state.loading = false;
        state.companytimeline =action.payload;
      })
      builder.addCase( CompanyTimeline.rejected, (state, action) => {
         state.loading = false;
      
      })
      
       // slice of comment  insert
       builder.addCase( CommentInsert.pending, (state, action) => {
        state.loading = false;
      })
      builder.addCase( CommentInsert.fulfilled , (state, action) => {
        state.loading = false;
        // state.companytimeline =action.payload;
      })
      builder.addCase( CommentInsert.rejected, (state, action) => {
         state.loading = false;
      
      })

       // slice of Get Comments
       builder.addCase( GetComment.pending, (state, action) => {
        state.loading = false;
      })
      builder.addCase( GetComment.fulfilled , (state, action) => {
        state.loading = false;
        state.getcomments =action.payload;
      })
      builder.addCase( GetComment.rejected, (state, action) => {
         state.loading = false;
      
      })

      // slice of delete post
      builder.addCase( DeletePost.pending, (state, action) => {
        state.loading = false;
      })
      builder.addCase( DeletePost.fulfilled , (state, action) => {
        state.loading = false;
        // state.getcomments =action.payload;
      })
      builder.addCase( DeletePost.rejected, (state, action) => {
         state.loading = false;
      
      })
  },

})



export default TimelineSlice.reducer